import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      toast.success(`Welcome back, ${res.user.name}`);
      navigate("/dashboard");
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-[calc(100vh-72px)] grid lg:grid-cols-2" data-testid="login-page">
      <div className="hidden lg:block relative">
        <img src="https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=1600" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-tr from-slate-950 via-slate-950/60 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12">
          <div className="overline mb-3">Member's Lounge</div>
          <h2 className="font-serif text-4xl text-slate-900 leading-tight">Sign in to track favorites, compare, and manage your listings.</h2>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={handleSubmit} data-testid="login-form" className="w-full max-w-md">
          <div className="overline mb-4">Welcome back</div>
          <h1 className="font-serif text-4xl text-slate-900 font-light mb-2">Sign in</h1>
          <p className="text-xs tracking-[0.25em] uppercase text-[#D4A437] mb-10">OC Infraventures Member's Lounge</p>

          {error && (
            <div className="mb-6 p-3 border border-red-500/30 bg-red-950/30 text-red-300 text-sm" data-testid="login-error">{error}</div>
          )}

          <label className="overline block mb-2">Email</label>
          <input
            type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email"
            className="w-full bg-slate-50 border border-slate-100 px-4 py-3 mb-5 focus:outline-none focus:border-amber-500"
          />
          <label className="overline block mb-2">Password</label>
          <input
            type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password"
            className="w-full bg-slate-50 border border-slate-100 px-4 py-3 mb-8 focus:outline-none focus:border-amber-500"
          />
          <button type="submit" disabled={submitting} data-testid="login-submit"
            className="w-full bg-[#D4A437] text-white py-3 font-medium hover:bg-[#D4A437] transition-colors disabled:opacity-60">
            {submitting ? "Signing in..." : "Sign In →"}
          </button>

          <div className="mt-6 text-sm text-slate-600 text-center">
            Don't have an account?{" "}
            <Link to="/register" className="text-[#D4A437] hover:underline" data-testid="link-to-register">Create one</Link>
          </div>
          <div className="mt-8 text-xs text-slate-500 text-center border-t border-slate-100 pt-6">
            Demo: <span className="text-slate-700">seller@ocinfraventures.com</span> · <span className="text-slate-700">Seller@123</span>
          </div>
        </form>
      </div>
    </div>
  );
}
